var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1521 15.6012L12.0212 11.5363C13.103 10.361 13.7676 8.80663 13.7676 7.09622C13.7671 3.43736 10.7534 0.47168 7.03553 0.47168C3.31766 0.47168 0.303955 3.43736 0.303955 7.09622C0.303955 10.7551 3.31766 13.7208 7.03553 13.7208C8.64191 13.7208 10.1152 13.1651 11.2725 12.2414L15.4195 16.3224C15.6216 16.5214 15.9496 16.5214 16.1517 16.3224C16.1997 16.2754 16.2379 16.2194 16.264 16.1575C16.2901 16.0956 16.3036 16.0291 16.3036 15.9619C16.3037 15.8947 16.2903 15.8282 16.2643 15.7663C16.2383 15.7043 16.2001 15.6482 16.1521 15.6012ZM7.03553 12.7015C3.8898 12.7015 1.3397 10.192 1.3397 7.09622C1.3397 4.00048 3.8898 1.4909 7.03553 1.4909C10.1813 1.4909 12.7314 4.00048 12.7314 7.09622C12.7314 10.192 10.1813 12.7015 7.03553 12.7015Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.444da7595b7451c84228fa182d32054f.svg";
export { ForwardRef as ReactComponent };